function LoginLoader() {
    return (
        <div className="login-loader">
        </div>

    )
}
export default LoginLoader